import React, { useState } from "react";
import { Button, Row, Col } from "react-bootstrap";

export default function ModerationView() {

  // Mock moderation queue
  const posts = [
    {
      id: 1,
      name: "Jane Doe",
      location: "Austin, TX",
      time: "2026-03-03 14:25",
      vibe: 7,
      urgent: 'High',
      text: "Power outage near campus, anyone else seeing this?",
      worked: true
    },
    {
      id: 2,
      name: "Mike Chen",
      location: "Dallas, TX",
      time: "2026-03-03 15:02",
      vibe: 3,
      urgent: 'Medium',
      text: "Anyone know a good coffee shop near UT?",
      worked: false
    }
  ];

  const studentInfo = [
    {
      id: 122867,
      name: "Jane Doe",
      gradeLevel: 10,
      age: 16
    }
  ]

  const [showStudentInfo, setShowStudentInfo] = useState(false);
  const [index, setIndex] = useState(0);
  const currentPost = posts[index];
  const currentStudent = studentInfo.find(
    (student)=> student.name === currentPost.name
  );

  const handleNext = () => {
    if (index < posts.length - 1) {
      setIndex(index + 1);
    }
  };

  const handleWorked = () => {
    console.log("Post marked as handled:", currentPost.id);
    handleNext();
  };

  return (
    <div className="moderation-container">

      <h2 className="admin-title">Moderation Queue</h2>

      {currentPost && (
        <div className="post-card">
          <Row>
            <Col className="col-border">
              <p><strong>Worked: <span style={{ color: currentPost.worked ? "green" : "red"}}>{currentPost.worked ? 'Yes' : 'No'}</span></strong></p>
              <p><strong>Name:</strong> <Button className="stuinfo" onClick={() => setShowStudentInfo(true)}>{currentPost.name}</Button></p>
              <p><strong>Location:</strong> {currentPost.location}</p>
              <p><strong>Time:</strong> {currentPost.time}</p>

              <p><strong>Vibe Meter:</strong> {currentPost.vibe}</p>

              <p>
                <strong>Urgency:</strong>{" "}
                {currentPost.urgent}
              </p>
            </Col>
            <Col className="col-border">
              {!showStudentInfo && (
                <>
                  <p><strong>Post:</strong></p>
                  <p>{currentPost.text}</p>
                </>
              )}
              {showStudentInfo &&(
                <>
                  <p><strong>Full Name: </strong> {currentStudent.name}</p>
                  <p><strong>Student ID: </strong> {currentStudent.id}</p>
                  <p><strong>Grade: </strong>{currentStudent.gradeLevel}</p>
                  <p><strong>Age: </strong>{currentStudent.age}</p>

                  <Button onClick={() => setShowStudentInfo(false)}>
                    Return to Post
                  </Button>
                </>
              )}
            </Col>
          </Row>

         

          <div style={{ marginTop: "20px" }}>
            <button onClick={handleWorked}>
              Flag as Worked
            </button>

            <button onClick={handleNext} style={{ marginLeft: "10px" }}>
              Next
            </button>
          </div>

        </div>
      )}

    </div>
  );
}